module.exports = __webpack_public_path__ + "img/53.9.TU.a201f12e.png";